export default __webpack_public_path__ + "media/images/courier_background-fcea7452e725ef64c49823f07210bc3e.png";